import React from 'react'
import { Chart } from "react-google-charts";
import { shadeDefault } from '../InsightsColors';

const InsightColumnGraphView =(props)=>{
    const {viewData, activeOption, onSelect} = props;

    const currentOption = activeOption || viewData.DefaultOption;
    
    //console.log("layout response view", viewData.ViewData[currentOption].ChartData);

    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        //console.log("layout response view", viewData.ViewData[currentOption].ChartData);
        const chartData = viewData.ViewData[currentOption].ChartData;

        const chartEvents = onSelect ? [
            {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const { row, column } = selection[0];
                        // row: index of the data row (excluding header)
                        // column: index of the data column
                        const dataRow = chartData[row + 1]; // +1 because first row is header
                        const dataColName = chartData[0][column];
                        const value = dataRow ? dataRow[column] : null;
                        // Do something with row, column, value, dataColName, dataRow
                        onSelect({ row, column, value, dataColName, dataRow });
                    }
                }
            }
        ] : [];
        
        return (
            <Chart
                chartType="ColumnChart"
                data={chartData}
                options={{
                    bar: { groupWidth: "75%" },
                    legend: { position: "bottom" },
                    hAxis: { title: viewData.X_AXIS_Title },
                    vAxis: { title: viewData.ViewData[currentOption].Y_AXIS_Title },
                    colors: shadeDefault,
                    isStacked: 'true',
                    animation: {
                        duration: 1000,
                        easing: "out",
                    },
                }}
                chartEvents={chartEvents}
                width="100%"
                height="100%"
            />
        )
    }

    return null;
}

export default InsightColumnGraphView
